module.exports = __webpack_public_path__ + "static/media/billing-info.c08ac9b1.svg";